import { queryClient } from "@/lib/query-client";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { type ReactNode, StrictMode } from "react";
import { Toaster } from "sonner";

/**
 * 브라우저(`main.tsx`)와 빌드 때 프리렌더(`entry-prerender.tsx`)가 똑같이 감싸는 트리.
 * 프리렌더한 HTML 을 hydrate 하려면 두 쪽 마크업이 한 글자도 다르지 않아야 하므로
 * 공급자를 한 곳에 둔다. 라우터만 쪽마다 다르다(BrowserRouter / StaticRouter).
 */
export function AppProviders({ children }: { children: ReactNode }) {
  return (
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        {children}
        <Toaster position="top-center" richColors />
        {import.meta.env.DEV && <ReactQueryDevtools initialIsOpen={false} />}
      </QueryClientProvider>
    </StrictMode>
  );
}

/** react-router v7 동작을 미리 켠다 — 페이지 이동이 transition 이 되어 lazy 청크를 받는 동안 지금 화면이 남는다. */
export const ROUTER_FUTURE = { v7_startTransition: true, v7_relativeSplatPath: true } as const;
